import { type BasicConfig, fromBasicConfig } from "@hopper-b2b/portal";
import { ClientName } from "@hopper-b2b/types";
import { v4 as uuidv4 } from "uuid";
import { styleOverrides } from "../src/overrides/stylesOverrides";
import { icons } from "../src/theme/icons";
import { images } from "../src/theme/images";
import { themeVariables } from "../src/theme/themeVariables";
import { branding } from "./branding";
import translations from "./translations";

const rbcPortalConfig: BasicConfig = {
  /** Add your client name to the ClientName enum if needed **/
  clientName: ClientName.RBC,
  // Environments and Datadog configuration
  bootConfig: {},
  theme: {
    variables: themeVariables,
    styleOverrides: styleOverrides,
    icons: icons,
    images: images,
  },
  featureFlags: {
    enablePricePrediction: true,
    copyConversationIdEnabled: true,
  },
  branding: branding,
  translations: translations,
  routerBasename: import.meta.env.BASE_URL,
};

export const environmentConfig = {
  env: import.meta.env.MODE,
  version: import.meta.env.VITE_REACT_APP_VERSION ?? `local-${uuidv4()}`,
  redirectURL: import.meta.env.VITE_INVALID_SESSION_REDIRECT_URL,
  preAuthMaintenanceEnabled: import.meta.env.VITE_ENABLE_PRE_AUTH_MAINTENANCE,
  preAuthMaintenanceTitleEn: import.meta.env.VITE_PRE_AUTH_MAINTENANCE_TITLE_EN,
  preAuthMaintenanceTitleFr: import.meta.env.VITE_PRE_AUTH_MAINTENANCE_TITLE_FR,
  preAuthMaintenanceSubtitleEn: import.meta.env
    .VITE_PRE_AUTH_MAINTENANCE_SUBTITLE_EN,
  preAuthMaintenanceSubtitleFr: import.meta.env
    .VITE_PRE_AUTH_MAINTENANCE_SUBTITLE_FR,
  timedMaintenanceModeEnabled: import.meta.env
    .VITE_TIMED_MAINTENANCE_MODE_ENABLED,
  timedMaintenanceModeStartTime: import.meta.env
    .VITE_TIMED_MAINTENANCE_MODE_START_TIME,
  timedMaintenanceModeEndTime: import.meta.env
    .VITE_TIMED_MAINTENANCE_MODE_END_TIME,
};

export default fromBasicConfig(rbcPortalConfig);
